/* Paylaşım araçları — ADV Studio
   1) [data-cart-share]  : sepetten cart permalink üretir (çekmece + sepet sayfası)
   2) [data-share-url]   : verilen linki paylaşır/kopyalar
   3) Ürün sayfası       : başlığın yanına ikon-buton otomatik eklenir
   Bu dosya cart-drawer üzerinden tüm sayfalarda yüklüdür. */
(function () {
  if (window.__cartShareInit) return;
  window.__cartShareInit = true;

  var SHARE_ICON = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M8 10V1.5M5.2 3.8L8 1l2.8 2.8"/><path d="M3 7.5v6h10v-6"/></svg>';
  var CHECK_ICON = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 8.5l3.5 3.5L13 5"/></svg>';

  /* ---------- Sepeti paylaş ---------- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-cart-share]');
    if (!btn) return;
    e.preventDefault();

    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const label = btn.querySelector('span') || btn;

        if (!cart.items || !cart.items.length) {
          flash(label, btn.getAttribute('data-empty-text'));
          return;
        }

        const pairs = cart.items
          .map(function (i) { return i.variant_id + ':' + i.quantity; })
          .join(',');
        const url = location.origin + root + 'cart/' + pairs + '?storefront=true';

        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            flash(label, btn.getAttribute('data-copied-text'));
          });
        }
      })
      .catch(function () {});
  });

  /* ---------- Genel link paylaşımı ---------- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-share-url]');
    if (!btn) return;
    e.preventDefault();

    const url = btn.getAttribute('data-share-url') || location.href;

    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { iconFlash(btn); });
    }
  });

  /* ---------- Ürün sayfası: ikon-buton enjeksiyonu ---------- */
  function initProductShare() {
    const title = document.querySelector('h1.product__title');
    if (!title || title.closest('.product__title-row')) return;

    if (!document.getElementById('product-share-style')) {
      const st = document.createElement('style');
      st.id = 'product-share-style';
      st.textContent =
        '.product__title-row{display:flex;align-items:flex-start;justify-content:space-between;gap:1.2rem;}' +
        '.product-share-btn{flex:none;width:3.4rem;height:3.4rem;display:grid;place-items:center;padding:0;' +
        'border:0.1rem solid rgba(var(--color-border),var(--alpha-border));border-radius:0;background:transparent;' +
        'color:inherit;cursor:pointer;transition:border-color .2s ease;}' +
        '.product-share-btn:hover{border-color:rgba(var(--color-foreground),1);}' +
        '.product-share-btn svg{width:1.5rem;height:1.5rem;}';
      document.head.appendChild(st);
    }

    const row = document.createElement('div');
    row.className = 'product__title-row';
    title.parentNode.insertBefore(row, title);
    row.appendChild(title);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'product-share-btn';
    btn.setAttribute('aria-label', 'Ürünü paylaş');
    btn.title = 'Paylaş';
    btn.setAttribute('data-share-url', location.origin + location.pathname);
    btn.innerHTML = SHARE_ICON;
    row.appendChild(btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductShare);
  } else {
    initProductShare();
  }
  document.addEventListener('shopify:section:load', initProductShare);

  /* ---------- Geri bildirim ---------- */
  function flash(el, text) {
    if (!text) return;
    const orig = el.textContent;
    el.textContent = text;
    setTimeout(function () { el.textContent = orig; }, 2200);
  }

  function iconFlash(btn) {
    if (btn.dataset.flashing) return;
    btn.dataset.flashing = '1';
    const orig = btn.innerHTML;
    btn.innerHTML = CHECK_ICON;
    setTimeout(function () {
      btn.innerHTML = orig;
      delete btn.dataset.flashing;
    }, 1800);
  }
})();
